import React, { useState, useEffect } from 'react';
import './PromoBanner.css'; // <-- add this import for the CSS

type PromoBannerProps = {
  classData: {
    class_date: string;
    class_url: string;
    topic: string;
  };
};

type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

const PromoBanner: React.FC<PromoBannerProps> = ({ classData }) => {
  const [isVisible, setIsVisible] = useState(true);

  const calculateTimeLeft = (): TimeLeft => {
    const difference = +new Date(classData.class_date) - +new Date();
    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  };

  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      if (
        newTimeLeft.days === 0 &&
        newTimeLeft.hours === 0 &&
        newTimeLeft.minutes === 0 &&
        newTimeLeft.seconds === 0
      ) {
        setIsVisible(false);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [classData.class_date]);

  if (!isVisible) return null;

  return (
    <div className="promo-banner">
      <div className="promo-banner__container">
      <div className="promo-banner__info">
        <div className="promo-banner__topic">{classData.topic}</div>
      </div>

      <div className="promo-banner__timer">
        {(['days', 'hours', 'minutes', 'seconds'] as (keyof TimeLeft)[]).map(
          (unit) => (
            <div key={unit} className="promo-banner__timer-unit">
              <div className="promo-banner__timer-value">
                {String(timeLeft[unit]).padStart(2, '0')}
              </div>
              <div className="promo-banner__timer-label">{unit.toUpperCase()}</div>
            </div>
          )
        )}
      </div>

      <a
        href={classData.class_url}
        target="_blank"
        rel="noopener noreferrer"
        className="promo-banner__button"
      >
        ENROLL NOW
      </a>

     <span className="promo-banner__close" onClick={() => setIsVisible(false)}>
  ✕
</span>
</div>
    </div>
  );
};

export default PromoBanner;
